import { Theme } from '@mui/material/styles';

export const mainContentStyles = (theme: Theme, isDark: boolean) => ({
  boxesContainer: {
    pt: 11,
    pb: 4,
    px: 12,
    [theme.breakpoints.down('md')]: { pb: 3, pt: 2.5 },
    [theme.breakpoints.down('lg')]: { px: 5 },
    [theme.breakpoints.up('lg')]: { pt: 14 },
    [theme.breakpoints.down('sm')]: { px: 2 }
  },
  cardContainer: {
    pr: 9,
    pl: 12,
    pb: 3,
    [theme.breakpoints.down('lg')]: { pl: 5, pr: 2 },
    [theme.breakpoints.down('md')]: { pr: 4 },
    [theme.breakpoints.down('sm')]: { pl: 2, pr: 1.5 }
  },
  title: {
    fontVariationSettings: "'wght' 300",
    pb: 1
  },
  subtitle: {
    textAlign: 'center'
  },
  onRamper: {
    cursor: 'pointer',
    textDecoration: 'none',
    [theme.breakpoints.down('md')]: {
      ml: 5,
      pb: 2
    },
    [theme.breakpoints.down('sm')]: {
      ml: 3
    }
  },
  circularProgress: {
    '& .MuiDialog-paper': {
      backgroundImage: 'none',
      boxShadow: 'none',
      backdropFilter: 'none'
    }
  },
  hideDialog: {
    display: 'none'
  }
});
